function createUniqueArray(allValues, field) {
    if (!Array.isArray(allValues) || 0 === allValues.length) return [];
    const set = new Set();
    return allValues.filter((item)=>{
        if (!(field in item)) return false;
        const fieldValue = item[field];
        const valueExists = set.has(fieldValue);
        if (!valueExists) set.add(fieldValue);
        return !valueExists;
    });
}
export { createUniqueArray };
